import { addDays } from 'date-fns'

interface GetDueDateFromSourceDocumentOptions {
  defaultDueDate: Date
  issueDate: Date
  isQuote?: boolean
  paymentTerm: number
  preserveSourceIdentity?: boolean
  sourceDueDate?: string
}

export const getDueDateFromSourceDocument = ({
  defaultDueDate,
  issueDate,
  isQuote,
  paymentTerm,
  preserveSourceIdentity,
  sourceDueDate,
}: GetDueDateFromSourceDocumentOptions): Date => {
  // QuoteEdit: the source quote is the document being edited, so keep its expiry date
  // instead of treating dueDate as a payment deadline.
  if (preserveSourceIdentity) {
    return sourceDueDate ? new Date(sourceDueDate) : defaultDueDate
  }

  // A duplicated quote's dueDate is its own expiry, not a payment deadline, so a new quote
  // starts a fresh validity period instead of following the payment term.
  if (isQuote) {
    return defaultDueDate
  }

  return addDays(issueDate, paymentTerm)
}
